<script>
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { writable } from "svelte/store";
  import Button from "$lib/components/Button.svelte";
  import LoadingIndicator from "$lib/components/LoadingIndicator.svelte";
  import Icon from "../Icon.svelte";
  import FormField from "./FormField.svelte";
  import { createEventDispatcher } from "svelte";

  export let formFields;
  export let buttonText;
  export let disable;
  export let isLoading;
  export let formId;
  export let uniqueId = "";
  export let buttonBelow = false;
  export let buttonVariant = "ghost";

  const formState = writable({});

  const dispatch = createEventDispatcher();

  function reduceFormDataToValuesObject(formData) {
    return formData.reduce((accumulator, value) => {
      const entries = Object.entries(value).flat();
      const [fieldName, fieldValue] = entries;
      return { ...accumulator, [fieldName]: fieldValue };
    }, {});
  }
  function handleChange(ev) {
    const { detail } = ev;
    formState.update((state) => ({
      ...state,
      // override the value for `detail.id` to reset the error message
      [detail.id]: { [detail.name]: detail.value }
    }));
  }

  function setErroredState(el) {
    let fieldData;
    formFields.forEach((fieldSet) => {
      fieldSet.fields.forEach((f) => {
        if (f.fieldProps.id === el.id) {
          fieldData = f;
        }
      });
    });
    const error = fieldData.fieldProps.errorMessage;

    formState.update((state) => ({
      ...state,
      [el.id]: { ...state[el.name], error }
    }));
  }

  function handleSubmit(ev) {
    ev.preventDefault();

    const formEl = ev.target;

    const erroredElements = [];
    const elements = formEl.elements;
    let hasErrors = false;
    for (let el of elements) {
      let fieldName = el.name.trim();
      if (fieldName) {
        let valid = el.validity.valid;
        if (!valid) {
          hasErrors = true;
          erroredElements.push(el);
          setErroredState(el);
        }
      }
    }

    if (hasErrors) {
      const firstErroredEl = erroredElements[0];
      firstErroredEl.focus();
    } else {
      const formData = Object.values($formState);
      const formValues = reduceFormDataToValuesObject(formData);
      dispatch("submit", formValues);
    }
  }

  const buttonFlexDirection = buttonBelow ? "flex-col" : "flex-row";
  const buttonClass = `h-fit gap-8 ${buttonBelow ? "" : "mt-24"}`;
</script>

<form
  id={formId}
  on:submit={handleSubmit}
  class={`flex ${buttonFlexDirection} gap-24 justify-center md:justify-start relative`}
  novalidate
>
  {#each formFields as fieldsTuple}
    <div
      class="flex flex-col md:flex-row gap-32 md:gap-24"
      class:md:flex-row={fieldsTuple.orientation === "horizontal"}
    >
      {#each fieldsTuple.fields as field}
        <div class={`flex-row md:flex-col ${field.fieldClass}`}>
          <FormField
            fieldType={field.fieldType}
            fieldProps={field.fieldProps}
            error={$formState[field.fieldProps.id]?.error ? field.fieldProps.errorMessage : false}
            on:clear={field.fieldProps.handleClear}
            on:change={handleChange}
            {uniqueId}
          />
        </div>
      {/each}
    </div>
  {/each}
  <Button
    disabled={disable}
    class={buttonClass}
    type="submit"
    size="small"
    variant={buttonVariant}
    id={uniqueId}
  >
    {buttonText}
    {#if isLoading}
      <LoadingIndicator containerClasses="justify-start h-24" spinnerClasses="w-24 h-24" />
    {:else}
      <Icon type="chevron-right" trailing />
    {/if}
  </Button>
</form>
